const FORWARD_MESSAGE_CODE_MESSAGES = {
	forward_message_invalid_payload: "Selecione entre 1 e 5 destinatários para encaminhar.",
	forward_message_not_found: "A mensagem não foi encontrada.",
	forward_message_deleted: "Não é possível encaminhar uma mensagem apagada.",
	forward_message_type_not_supported: "Este tipo de mensagem não pode ser encaminhado.",
	forward_message_media_expired: "A mídia desta mensagem expirou e não pode ser encaminhada.",
	forward_message_media_unavailable: "Não foi possível acessar a mídia desta mensagem.",
	forward_message_unauthorized: "Você não tem acesso a esta conversa.",
	forward_message_failed: "Falha ao enviar a mensagem.",
	forward_target_groups_not_allowed: "Encaminhar para grupos não está disponível neste canal.",
	forward_target_waba_window_closed: "Janela de comunicação inativa. Envie um template para reabrir a conversa.",
	forward_target_chat_not_found: "Conversa não encontrada.",
	forward_target_attended_by_another_user: "Em atendimento com outro atendente — você não tem permissão para encaminhar."
}

export default FORWARD_MESSAGE_CODE_MESSAGES
